export const inventoryTranslations = {
  // Page title and description
  items: "Items",
  manageInventoryItems: "Manage your inventory items",
  
  // Actions
  newItem: "New Item",
  
  // States
  loadingItems: "Loading items...",
  errorLoadingItems: "Error loading items",
  unknownError: "Unknown error",
  noResults: "No results.",
  
  // Search
  searchPlaceholder: "Search by SKU or Product Name...",
  
  // Column headers
  itemCode: "Item Code",
  itemName: "Item Name",
  itemGroup: "Item Group",
  uom: "UOM",
  unitOfMeasure: "Unit of Measure",
  rate: "Rate",
  standardRate: "Standard Rate",
  stockItem: "Stock Item",
  
  // Column placeholders
  searchItemCodes: "Search item codes...",
  searchItemNames: "Search item names...",
  selectGroup: "Select group...",
  selectUom: "Select UOM...",
  filterByRate: "Filter by rate...",
  select: "Select...",
  
  // Values
  yes: "Yes",
  no: "No",
  
  // Toolbar
  addFilter: "Add Filter",
  filters: "Filters",
  manageFilters: "Manage filters",
  reset: "Reset",
  resetFilters: "Reset filters",
  view: "View",
  viewList: "List",
  viewBoard: "Board",
  viewTable: "Table",
  viewAdvanced: "Advanced",
  filter: "Filter",
  advanced: "Advanced",
  toggleColumns: "Toggle columns",
  searchColumns: "Search columns...",
  noColumnsFound: "No columns found.",
  
  // Sort options
  lastUpdatedOn: "Last Updated On",
  createdOn: "Created On",
  mostUsed: "Most Used",
  maintainStock: "Maintain Stock",
  standardSellingRate: "Standard Selling Rate",
  id: "ID",
  sortBy: "Sort by",
  sortDescending: "Sort descending",
  sortAscending: "Sort ascending",
  descending: "Descending",
  ascending: "Ascending",
  
  // Filter modal
  addAndManageFilters: "Add and manage filters to refine your search results",
  applyFilters: "Apply Filters",
  clearFilters: "Clear Filters",
  filterBy: "Filter By",
  advancedFilters: "Advanced Filters",
  filterByAssignedCreatedTags: "Filter by assigned users, creators, and tags",
  assignedTo: "Assigned To",
  assignedToAny: "ANY",
  assignedToAll: "ALL",
  createdBy: "Created By",
  tags: "Tags",
  selectUser: "Select user...",
  enterTagNames: "Enter tag names...",
  removeUser: "Remove user",
  removeTag: "Remove tag",
  removeFilter: "Remove filter",
  clearAll: "Clear All",
  loadingTags: "Loading tags...",
  noTagsFound: "No tags found. Press Enter or comma to add.",
  startTypingToSearchTags: "Start typing to search tags...",

  // ── Advanced Table View ──────────────────────────────────────────────
  // Filter
  advFilterWhere: "Where",
  advFilterAnd: "and",
  advFilterAddFilter: "Add filter",
  advFilterClearAll: "Clear all",
  advFilterNoFilters: "No filters applied. Click \"Add filter\" to get started.",
  advFilterSelectField: "Select field...",
  advFilterSearchFields: "Search fields...",
  advFilterNoFields: "No fields found.",
  advFilterOperator: "Operator...",
  advFilterValue: "Value...",
  advFilterSelect: "Select...",
  advFilterYes: "Yes",
  advFilterNo: "No",
  advFilterMin: "Min",
  advFilterMax: "Max",

  // Operator labels
  advOpContains: "Contains",
  advOpIs: "Is",
  advOpIsNot: "Is not",
  advOpDoesNotContain: "Does not contain",
  advOpIsNotEmpty: "Is not empty",
  advOpIsEmpty: "Is empty",
  advOpEquals: "Equals",
  advOpNotEquals: "Not equals",
  advOpGreaterThan: "Greater than",
  advOpLessThan: "Less than",
  advOpGreaterOrEqual: "Greater or equal",
  advOpLessOrEqual: "Less or equal",
  advOpBetween: "Between",
  advOpAfter: "After",
  advOpBefore: "Before",
  advOpIsAnyOf: "Is any of",
  advOpIsNoneOf: "Is none of",

  // Sort
  advSort: "Sort",
  advSortRules: "Sort rules",
  advSortAdd: "Add sort",
  advSortClearAll: "Clear all",
  advSortNoRules: "No sort rules. Click below to add one.",
  advSortSelectField: "Select field",
  advSortAscending: "Ascending",
  advSortDescending: "Descending",

  // Action bar
  advActionSelected: "selected",
  advActionSetStatus: "Set Status",
  advActionEnable: "Enable",
  advActionDisable: "Disable",
  advActionExportCSV: "Export CSV",
  advActionArchive: "Archive",
  advActionCancel: "Cancel",
  advActionArchiveTitle: "Archive",
  advActionArchiveDescription: "They will be hidden from active lists but can be restored.",
  advActionArchiveConfirm: "Archive",

  // Toast messages
  advToastEnabled: "enabled",
  advToastDisabled: "disabled",
  advToastArchived: "archived",
  advToastFailedUpdate: "Failed to update status",
  advToastFailedArchive: "Failed to archive items",
  advActionRestore: "Restore",
  advToastRestored: "restored",
  advToastFailedRestore: "Failed to restore items",
  advToastPartialFail: "items failed to update",

  // Empty state
  advEmptyTitle: "No items found",
  advEmptyDescription: "Try adjusting your filters or search query.",

  // Column visibility
  advColumns: "Columns",
  advColumnsSearch: "Search columns...",
  advColumnsEmpty: "No columns found.",

  // Toolbar
  advFilters: "Filters",

  // Data Grid — Edit mode
  dgEditBanner: "Editing mode — changes save automatically",
  dgToggleEditMode: "Toggle edit mode",

  // Data Grid — Context menu
  dgCopy: "Copy",
  dgPaste: "Paste",
  dgClearCell: "Clear cell",
  dgViewDetail: "View detail",

  // Data Grid — Paste dialog
  dgPasteTitle: "Paste values",
  dgPasteDescription: "Review the changes below before applying.",
  dgPasteCurrent: "Current",
  dgPasteNew: "New",
  dgPasteMore: "more",
  dgPasteSaving: "Saving",
  dgPasteApply: "Apply",
  dgPasteSavingBtn: "Saving...",
  dgCancel: "Cancel",

  // Data Grid — Conflict
  dgConflictTooltip: "Modified by another user",

  // Data Grid — Keyboard help
  dgKeyboardHelp: "Keyboard shortcuts",
  dgNavigation: "Navigation",
  dgEditing: "Editing",
  dgClipboard: "Clipboard",
  dgUndoRedo: "Undo / Redo",
  dgShortcutTab: "Next / previous cell",
  dgShortcutEnter: "Move down",
  dgShortcutEscape: "Cancel edit",
  dgShortcutArrows: "Navigate cells",
  dgShortcutHome: "First cell in row",
  dgShortcutEnd: "Last cell in row",
  dgShortcutCtrlHome: "First cell in table",
  dgShortcutCtrlEnd: "Last cell in table",
  dgShortcutPageUp: "Page up",
  dgShortcutPageDown: "Page down",
  dgShortcutCtrlZ: "Undo",
  dgShortcutCtrlShiftZ: "Redo",
  dgShortcutCtrlC: "Copy cell",
  dgShortcutCtrlV: "Paste",
  dgShortcutCtrlX: "Cut cell",
  dgShortcutQuestion: "Show shortcuts",

  // ── Promotions (PricingCard / PromotionPill) ─────────────────────────
  promoPromotions: "Promotions",
  promoActions: "Promotion actions",
  promoEndConfirmation: "End this sale immediately? Customers will see the original price.",
  promoEndSale: "End Sale",
  promoKeepIt: "Keep it",
  promoHideBadge: "Hide badge on storefront",
  promoShowBadge: "Show badge on storefront",
  promoDisableStorefront: "Disable for storefront",
  promoEnableStorefront: "Enable for storefront",
  promoEditPromotion: "Edit promotion",
  promoEndNow: "End now",
  promoEnds: "ends",
  promoFrom: "from",
  promoScopeItem: "This product only",
  promoScopeVariants: "Applies to all variants",
  promoScopeCategory: "Category:",
  promoScopeBrand: "Brand:",
  promoScopeStore: "All products in store",
  promoEnabled: "Enabled",
  promoDisabled: "Disabled",

  // ── PricingCard ────────────────────────────────────────────────────────
  pricingSellingPrice: "Selling Price",
  pricingRunASale: "Run a Sale",
  pricingTemplateMessage: "This is a template item. Set prices on individual variants.",
  pricingHowMuch: "How much do you want to charge?",
  pricingStorefrontNote: "This is what customers will see on your storefront",
  pricingSetSellingPrice: "Set Selling Price",
  pricingSavingItem: "Saving item…",
  pricingSelectUnitFirst: "Please select a Unit first",
  pricingUnitRequired: "The Unit field is required before setting a price.",
  pricingCouldNotSave: "Could not save the item",
  pricingFillRequired: "Fill in the required fields and try again.",
  pricingNoPricing: "No pricing set up yet",
  pricingAddPriceListToStart: "Add a price list to get started",
  pricingCouldNotLoad: "Couldn't load pricing data",
  pricingRetry: "Retry",
  pricingUpdatedTo: "Price updated to",
  pricingUndo: "Undo",
  pricingRevertedTo: "Price reverted to",
  pricingUndoFailed: "Failed to undo. Please update the price manually.",
  pricingPromoEnded: "Promotion ended",
  pricingPromoEndFailed: "Failed to end promotion",
  pricingAddPriceList: "+ Add price list",
  pricingPreviewAs: "Preview as:",

  // ── PricingRow ─────────────────────────────────────────────────────────
  pricingBase: "Base",
  pricingCustomerPays: "Customer pays",
  pricingAppliedRule: "Applied rule",
  pricingOtherRules: "Other rules active on this price list",
  pricingNotAppliedLower: "not applied — lower priority",
  pricingNotAppliedOverride: "not applied — storefront override",
  pricingSetPrice: "Set selling price",
  pricingAddBasePrice: "Add a base price for your storefront",
  pricingPrimaryOnShop: "Primary · on shop",
  pricingInternal: "Internal",
  pricingSave: "save",
} as const;

